export const ServicePillarType: {
    AESTHETIC: 'AESTHETIC',
    COSMETIC: 'COSMETIC',
    HEALTH: 'HEALTH',
} = {
    AESTHETIC: 'AESTHETIC',
    COSMETIC: 'COSMETIC',
    HEALTH: 'HEALTH',
};

export type ServicePillarType = (typeof ServicePillarType)[keyof typeof ServicePillarType];

export const getServicePillarTypeLabel = (type: ServicePillarType): string => {
    switch (type) {
        case ServicePillarType.AESTHETIC:
            return 'Ästehtisch';
        case ServicePillarType.COSMETIC:
            return 'Kosmetisch';
        case ServicePillarType.HEALTH:
            return 'Gesundheit';
        default:
            return 'Unbekannt';
    }
};